import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React, { useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import { Backdrop, Box, CircularProgress } from '@material-ui/core';
import MainAuthorsForm from './MainAuthorsForm';
import WarningIcon from '@mui/icons-material/Warning';
import { pink } from '@mui/material/colors';
import { observer } from 'mobx-react';
import MainAuthorsBooksList from './MainAuthorsBooksList';

const MainAuthorsContent = observer(({mainAuthorsFormStore: store}) => {
  const [activeTab, setActiveTab] = useState(0);
  const getTabIcon = tab => {
    if (store.tabsErrors[tab]) {
      return <WarningIcon sx={{ color: pink[500] }} />;
    }

    return <CheckCircleIcon color='success' />;
  };

  return (
    <div>
      {store.loading && <Backdrop open={store.loading}><CircularProgress  /></Backdrop>}
      <Box display="flex" justifyContent="flex-end">
        <Tabs value={activeTab} onChange={(e, v) => setActiveTab(v)}>
          <Tab icon={getTabIcon(0)} iconPosition="start" label="Informações Gerais" />
          {!store.isNew && <Tab iconPosition="start" label="Livros-pai Vinculados" />}
        </Tabs>
      </Box>
      {activeTab === 0 && <MainAuthorsForm mainAuthorsFormStore={store} />}
      {activeTab === 1 && <MainAuthorsBooksList mainAuthorsFormStore={store} /> }
    </div>
  );
});

export default MainAuthorsContent;
